
import * as actions from './actionsTypes';

const initialData = {
  loadingAuth: false,
  loaderResetPass: false,
  saveLoading: false,
  userId: '',
  token: '',
  username: '',
  recoverPass: false,
  resetPass: false,
  users: [],
  usersLength: 0,
  roles: [],
  ficha_formal: {},
  id: '',
  name: '',
  userRoles: [],
  pic: '',
  unidOrg: null,
  unidName: '',
  userOrg: null,
  userUpdated: false,
  userType: 2
}

export default function authReducer(state = initialData, action){
  switch (action.type) {
    case actions.LOADING_AUTH:
      return {...state, loadingAuth: action.payload}
    case actions.LOADER_RESET_PASS:
      return {...state, loaderResetPass: action.payload}
    case actions.SAVE_lOADER_USER:
      return {...state, saveLoading: action.payload}
    // case actions.LOADING_VERIFICATION:
    //   return {...state, loadingVerification: action.payload}
    // case actions.SAVE_LOADER_VERIFICATION:
    //   return {...state, saveLoadingVerification: action.payload}
    // case actions.GET_VERIFICATION:
    //   return {...state, verifUserName: action.payload.verifUserName, verifEmail: action.payload.verifEmail}
    case actions.GET_TOKEN:
      return {...state,
              userId: action.payload.userId, 
              token: action.payload.token, 
              username: action.payload.username, 
              id: action.payload.id,
              name: action.payload.name,
              userRoles: action.payload.userRoles,
              pic: action.payload.pic,
              unidOrg: action.payload.unidOrg,
              unidName: action.payload.unidName,
              userOrg: action.payload.userOrg,
              userUpdated: action.payload.userUpdated,
              userType: action.payload.userType
            }
    case actions.RECOVER_PASS:
      return {...state, recoverPass: action.payload}
    case actions.RESET_PASS:
      return {...state, resetPass: action.payload}
    case actions.GET_USERS:
      return {...state, users: action.payload.users, usersLength: action.payload.usersLength, roles: action.payload.roles}
    case actions.GET_FORMAL_FICHA:
      return {...state, ficha_formal: action.payload}
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.FORM_PASSWORD_FAIL:
      return { ...state, formPasswordError: action.payload };
    case actions.USER_FAIL:
      return { ...state, userError: action.payload };
    case actions.ADD_USER:
      const userExists = state.users.find(user => user.id === action.payload.id);
      if (!userExists) {
        return { ...state, users: [...state.users, action.payload] };
      }
      return state;
    default:
      return state
  }
}